import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteAppointmentModal = ({ isOpen, onClose, onConfirm, appointmentInfo, isLoading }) => {
  // ESC key handler to close modal
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event?.key === 'Escape' && isOpen && !isLoading) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, isLoading, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card rounded-xl shadow-2xl border border-border w-full max-w-md">
        <div className="p-6">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-destructive/10 mb-4">
            <Icon name="AlertTriangle" size={24} className="text-destructive" />
          </div>

          <h2 className="text-xl font-semibold text-foreground mb-2">
            Excluir Agendamento
          </h2>
          <p className="text-sm text-muted-foreground mb-4">
            Isto é definitivo. Excluir mesmo o agendamento? 
          </p>

          {appointmentInfo && (
            <div className="bg-muted/50 border border-border rounded-lg p-3 mb-6">
              <div className="space-y-1">
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="User" size={14} className="text-muted-foreground flex-shrink-0" />
                  <span className="text-foreground font-medium">{appointmentInfo?.patientName}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="Calendar" size={14} className="text-muted-foreground flex-shrink-0" />
                  <span className="text-muted-foreground">{appointmentInfo?.date}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="Clock" size={14} className="text-muted-foreground flex-shrink-0" />
                  <span className="text-muted-foreground">{appointmentInfo?.time}</span>
                </div>
              </div>
            </div>
          )}

          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
              fullWidth
            >
              Retornar
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              loading={isLoading}
              iconName="Trash2"
              iconPosition="left"
              fullWidth
            >
              Excluir Agendamento
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAppointmentModal;